export function getAuthUrl(path: string, idsUrl: string) {
  const { href } = new URL(path, idsUrl);
  return href;
}
